$('.btn-num-order-down').unbind().bind('click', function (e) {  
   e.preventDefault();
    var numCtrl = $(this).next();
    var numProduct = Number(numCtrl.html());
    numProduct = numProduct > 1 ? numProduct - 1 : 1;        
    numCtrl.html(numProduct);
 });

 $('.btn-num-order-up').unbind().bind('click', function (e) { 
   e.preventDefault();      
    var numCtrl = $(this).prev();
    var numProduct = Number(numCtrl.html());
    numProduct += 1;        
    numCtrl.html(numProduct);    
 
 });

 
 